import Insight from "../insightClass";
import React from "react";
import { insight32Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight059 = new Insight(
  "15 August 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight32Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-08-15)",
  "",
  `Analysts estimate that roughly 37% of Scotland’s potential wind output—around 4 TWh—was curtailed in H1 2025. The primary drivers are constrained transmission from the north, limited cross-regional transfer capability, and modest local demand. To keep the GB system in balance, the system operator ramps gas generation elsewhere and pays constraint compensation to curtailed wind farms, pushing overall system costs higher. `,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-08-15)</h1>
    <h2></h2>
    <p className="article-date">15 August 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. Scotland’s surging wind curtailment raises cost and grid-capacity
      concerns
    </h3>
    <p>
      Analysts estimate that roughly 37% of Scotland’s potential wind
      output—around 4 TWh—was curtailed in H1 2025. The primary drivers are
      constrained transmission from the north, limited cross-regional transfer
      capability, and modest local demand. To keep the GB system in balance, the
      system operator ramps gas generation elsewhere and pays constraint
      compensation to curtailed wind farms, pushing overall system costs higher.
      With more offshore wind set to connect, these pressures could intensify.
      In response, the government and the National Energy System Operator (NESO)
      are advancing inter-regional reinforcements and incentive reforms aimed at
      reducing curtailment and the frequency of negative prices.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Build constraint costs and negative-price frequency directly into AR7
      models—not just the base-case IRR but the tails. The most effective
      asset-side hedge is to colocate flexible demand and storage at the
      resource: think data centres, electrolysers, industrial steam loads, and
      grid-scale batteries to create a local “consumption loop.” On the grid
      side, engage early in offshore hubs, multi-terminal HVDC, and
      congestion-management pilots to unlock both capacity and flexibility
      revenues. Over the medium term, partnering with NESO on anticipatory
      transmission and zonal-pricing reform can turn today’s “good wind,
      stranded value” discount into upside optionality.
    </p>
    <h3>
      2. Ørsted launches ~DKK 60bn rights issue; shares plunge nearly 30%
      intraday 
    </h3>
    <p>
      Ørsted announced a c. DKK 60bn (~US$9.4bn) rights issue to stabilise its
      balance sheet and provide headroom for 2025–27 builds. Funding needs have
      risen amid U.S. policy uncertainty and slower-than-planned sell-down of
      Sunrise Wind. Denmark’s government will subscribe pro rata, with the
      remainder underwritten by Morgan Stanley. The stock dropped almost 30%
      intraday on 11 August, touching a nine-year low. Ørsted maintained 2025
      EBITDA and capex guidance and reiterated asset-recycling plans, including
      disposals across European onshore and partial stakes in selected offshore
      projects. The rise is a bellwether for refinancing and risk pricing in a
      high-rate, policy-volatile era for offshore wind.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Treat this as a balance-sheet reset—shifting high-uncertainty project risk
      into priced equity risk. Near term, accelerate asset recycling and JV
      structures to surface embedded value, and recast risk sharing in EPCI and
      main-equipment contracts via indexation, reopeners, and staged price
      locks. In the U.S., blend deeper hedging, tighter localisation, and mixed
      routes to market (state contracts/CfDs plus corporate PPAs) to improve
      bankability. On financing, consider green convertibles or
      sustainability-linked loans to bridge to post-COD refinancings and lower
      WACC.
    </p>
    <h3>
      3. Poland installs first 15 MW turbines at Baltic Power—its first offshore
      wind farm
    </h3>
    <p>
      ORLEN and Northland Power have installed the first five of 76 Vestas 15 MW
      turbines at the 1.2 GW Baltic Power project, Poland’s inaugural offshore
      wind farm. The heavy-lift jack-up Wind Osprey is leading the campaign,
      with commissioning targeted for 2026 and first power possible in 2025–26
      if array and export systems align. Beyond Poland, the milestone signals
      mainstream adoption of 15 MW-class machines in European waters and a
      maturing Baltic logistics chain. Located ~23 km offshore, Baltic Power
      will materially diversify Poland’s coal-heavy generation mix while
      anchoring domestic supply-chain capabilities.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      In the mega-turbine era, port capability and marine choreography—port ↔
      vessel ↔ weather—become the gating factors. Front-load dynamic-cable and
      other long-lead components, and lock in spares/warranty strategies to
      shorten the reliability ramp. Use parallelised assembly and distributed
      heavy-lift quays to compress the weather-critical path. With Polish
      localisation accelerating, early commitments in towers, cables, and
      secondary steel can secure cost deflation and bargaining power across the
      next 6–8 GW.
    </p>
    <h3>
      4. Europe’s persistent negative prices: from “produce more” to “use/store
      more”
    </h3>
    <p>
      Several European markets continue to see frequent negative prices and
      rising curtailment payments—symptoms of a structural mismatch between
      fast-growing renewables capacity and slower progress on demand flexibility
      and grid upgrades. Without long-distance transmission, storage, and
      flexible consumption, the simple “more renewables = cheaper power” story
      is offset by the cost of spillage. Policy attention is shifting to dynamic
      pricing, inter-regional transmission, harmonised market rules, and scaled
      storage to capture surplus value. With AI data centres and EV loads
      surging, today’s “excess” can become tomorrow’s resilience—if matched
      correctly.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Value capture is moving from maximising MWh to optimising MW × hours ×
      price quality. Design offshore projects as hybrids—with storage, PV, and
      flexible offtake—to reshape output and upgrade the value of each MWh.
      Layer floor/“collar” corporate PPAs with capacity and ancillary-service
      revenues to smooth cash flows. Cross-border HVDC and zonal-pricing reform
      are structural tailwinds, turning curtailment into tradable congestion
      value. Judge long-term competitiveness by “capacity factor × price
      quality,” not LCOE alone.
    </p>
    <h3>
      5. Colombia unveils 15-year CfD and opens the first tender (offshore
      eligible)
    </h3>
    <p>
      Colombia’s Ministry of Energy has issued Decree 40337 (2025), launching a
      15-year Contracts-for-Difference scheme with an initial round that
      evaluates both feasibility and price/non-price factors across
      technologies, including eligibility for offshore wind. While Latin
      America’s offshore market is nascent, this is a meaningful policy
      breakthrough that could enable near-coast site development and spur
      port/component localisation.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      In early-stage markets, bankability comes first. Pair the CfD cash-flow
      anchor with local JVs, FX/inflation hedging, and blended finance from
      multilaterals or policy banks to temper country and currency risk. Site
      selection should balance wind resource, water depth, port access, and
      environmental sensitivities, with hurricane/extreme-weather resilience
      built into design. For system integration, coordinated operation with gas
      or existing baseload improves acceptability; binding localisation and jobs
      plans can unlock permits and fiscal support.
    </p>
    <h3>
      6. Vestas Q2: profit miss but guidance intact; EMEA demand resilient
    </h3>
    <p>
      Per Reuters, Vestas reported Q2 2025 operating profit of €57m (vs. €89m
      consensus), a sharp improvement from last year’s loss. The company kept
      full-year revenue guidance of €18–20bn and an EBIT margin of 4–7%.
      Management highlighted resilient EMEA demand, while policy uncertainty
      continues to weigh on several key markets. Although offshore remains a
      smaller share of group revenue, ramp-up discipline and cost control on
      high-rating, large-diameter platforms will heavily influence Europe’s
      2026–28 delivery capacity and pricing curves.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The supply side has entered a profit-repair phase with widening
      dispersion. Developer “winners” will align procurement cadence and
      technology choices with supplier ramp curves. Prioritise framework
      agreements with manufacturers that have European capacity and control of
      critical steps, trading firm reservations and price reopeners for delivery
      certainty. In the high-rating era, main bearings, castings, and blade
      logistics drive bullwhip effects—embed inflation, FX, and logistics
      mitigants contractually. Plan O&M bases and critical spares in parallel to
      keep early-life availability within IRR guardrails.
    </p>
    <h3>
      7. Massachusetts delays its 5th offshore wind solicitation to no earlier
      than 2026
    </h3>
    <p>
      The Department of Energy Resources (DOER) confirmed that the 83C V
      solicitation will not launch before 2026, mainly because contracts from
      the prior 83C IV round remain unfinished amid federal policy uncertainty.
      Avangrid’s New England Wind 1 (791 MW) and SouthCoast Wind (1,087 MW)
      continue negotiations with utilities, targeting completion by 31 December
      2025; Vineyard Offshore (800 MW) has exited. The state has appointed an
      independent evaluator and begun drafting a new RFP, but cannot fully
      incorporate 83C IV lessons until those contracts are finalised. The delay
      will ripple through New England’s port, vessel and financing schedules in
      the short term, while creating space to recalibrate pricing mechanics and
      delivery terms for the next round.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The deferral carves out time for contract and policy certainty. Developers
      should use rolling FIDs and staged grid connections to sequence
      construction and financing, and blend routes to market—state contracts
      plus corporate PPAs—to reduce single-buyer and single-policy exposure.
      Supply chains need to re-slot WTIVs, dynamic cables and port windows, with
      EPCI contracts carrying deferral and price-reopener provisions to hedge
      federal incentives and tariff shifts. For European/UK suppliers and
      capital, temporarily pivoting capacity back to Britain and Europe (e.g.,
      AR7 and continental buildouts) while preserving 2026 East Coast
      optionality is the prudent cross-regional allocation.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
